import './assets/App.css';

import { Container } from "react-bootstrap";
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Main from './containers/Main';
import ThankYou from './containers/ThankYou';
import NotEnrol from './containers/NotEnrol';
import { ApplicantContainer } from "./unstated/applicant";
import IEDetected from "./containers/IEDetected";


export function App() {

  // Internet Explorer 6-11
  const isIE =
    /*@cc_on!@*/ false || !!document.documentMode;

  if (isIE) {
    return <IEDetected />;
  }

  return (
    <ApplicantContainer.Provider>
      <div className="App">

        <Container fluid="xl">       

          <Router basename={"/scholarship-app"}>          
            <Switch>
              <Route path="/" exact children={<Main />} />                        
              <Route path="/thank-you" children={<ThankYou />} />
              <Route path="/not-enrol" children={<NotEnrol />} />
            </Switch>
          </Router> 
 
        </Container>      
      </div>
    </ApplicantContainer.Provider>
  );
}
